import { router } from '@inertiajs/vue3';
import { ref, watch } from 'vue';

export default function useStepper(props) {
  const currentStep = ref(props.stepper.current.stepKey ?? 'Default');
  const steps = ref(props.stepper.steps);
  const before = ref(props.stepper.options.before);
  const after = ref(props.stepper.options.after);

  const updateStep = (url, step) => {
    if (props.stepper.options.method == 'post') {
      let attributes = props.resource.data.attributes;
      attributes.step = step;
      router.post(url, attributes);
    } else {
      router.patch(url, { step, data: { attributes: props.resource.data.attributes } });
    }
  };

  const getStepperClass = (step) => {
    let stepKeys = props.stepper.steps;
    if (stepKeys.indexOf(step) < stepKeys.indexOf(props.stepper.current.stepKey)) {
      return 'checked';
    }

    if (stepKeys.indexOf(step) > stepKeys.indexOf(props.stepper.current.stepKey)) {
      return 'disabled';
    }

    return '';
  };

  const getOptions = () => {
    return {
      title: props.stepper.current.title,
      description: props.stepper.current.description,
      imagePath: props.stepper.options.imagePath,
      showTitles: props.stepper.options.showTitles,
    };
  };

  const next = () => {
    let steps = props.stepper.steps;
    let nextIndex = steps.indexOf(currentStep.value) + 1;

    if (nextIndex >= steps.length) {
      return null;
    }

    let nextStep = steps[nextIndex];

    return { key: nextStep, text: props.stepper.buttons[nextStep].next };
  };

  const previous = () => {
    let steps = props.stepper.steps;
    let previousIndex = steps.indexOf(currentStep.value) - 1;

    if (previousIndex < 0) {
      return null;
    }

    let previousStep = steps[previousIndex];

    return { key: previousStep, text: props.stepper.buttons[previousStep].previous };
  };

  const triggerNext = (allowed, url) => {
    if (allowed) {
      progressionDenied.value = false;
      updateStep(url, next()?.key);
    }
  };

  const progressionDenied = ref(false);

  const denyProgression = (denied) => {
    progressionDenied.value = denied;
  };

  watch(
    () => props.stepper.current.stepKey,
    (updatedValue) => {
      currentStep.value = updatedValue;
    }
  );

  return {
    after,
    before,
    currentStep,
    denyProgression,
    getOptions,
    getStepperClass,
    next,
    previous,
    progressionDenied,
    steps,
    triggerNext,
    updateStep,
  };
}
